function read(name, cookies = document.cookie) {
  const nameEQ = name + '='
  const ca = cookies.split(';')

  for (let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) === ' ') c = c.substring(1, c.length)
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length)
  }
  return null
}

function hasConsent(consentLevel) {
  const termsFeedConsentLevel = read('cookie_consent_level')
  let consent = false

  // Accepted consentLevel param are "strictly-necessary", "functionality", "tracking" and "targeting"
  if (termsFeedConsentLevel) {
    const consentString = decodeURIComponent(termsFeedConsentLevel)
    const startIndex = consentString.indexOf(consentLevel) + consentLevel.length + 2
    const consentValueSubstr = consentString.substring(startIndex, startIndex + 5) // should return "true," or "false"
    consent = consentValueSubstr.includes('true')
  }

  return consent
}

module.exports = {
  hasConsent,
  read
}
